import CancelButton from "../../../Buttons/CancelButton";
import SaveButton from "../../../Buttons/SaveButton";

export default function ModalActions({ onCancel, onSave, disabled, modeLabel }) {
  return (
    <div className="flex gap-6 py-4">
      <CancelButton onClick={onCancel} />
      <SaveButton disabled={disabled} onClick={onSave} label={`${modeLabel} Contact`} />
    </div>
  );
}
